export const WithDrawIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.5" clip-path="url(#clip0_786_32782)">
      <path
        d="M5.63772 3.35155C5.79562 3.35155 5.94836 3.28606 6.0575 3.17166L7.20349 2.03093V5.63644C7.20349 5.96424 7.47015 6.23095 7.79795 6.23095C8.12575 6.23095 8.39242 5.96429 8.39242 5.63644V2.03098L9.54047 3.17373C9.77089 3.40406 10.1458 3.40406 10.3761 3.17373C10.4877 3.06215 10.5492 2.91381 10.5492 2.75596C10.5492 2.59816 10.4877 2.44982 10.3761 2.33824L8.21792 0.180027C8.10878 0.0655411 7.95595 0 7.79795 0C7.63996 0 7.48713 0.0655411 7.37798 0.180027L5.22207 2.33594C5.10758 2.44495 5.04199 2.59773 5.04199 2.75596C5.04199 2.91292 5.10669 3.06473 5.21972 3.17373C5.32877 3.28681 5.48067 3.35155 5.63772 3.35155Z"
        fill="black"
      />
      <path
        d="M14.2765 7.60986H0.594418C0.266665 7.60986 0 7.87653 0 8.20428V14.6854C0 15.4102 0.589776 15.9999 1.31471 15.9999H14.9968C15.3245 15.9999 15.5912 15.7333 15.5912 15.4055V8.92458C15.5912 8.19964 15.0014 7.60986 14.2765 7.60986ZM1.31471 14.811C1.24533 14.811 1.18888 14.7546 1.18888 14.6854V8.79874H14.2765C14.3459 8.79874 14.4024 8.85519 14.4024 8.92458V14.811H1.31471Z"
        fill="black"
      />
      <path
        d="M7.79625 9.77051C6.97028 9.77051 6.2324 10.2635 5.91646 11.0265C5.60029 11.7896 5.77347 12.66 6.35753 13.2438C6.74768 13.6341 7.26559 13.8409 7.79404 13.8409C8.05653 13.8409 8.32165 13.7898 8.57486 13.6849C9.33782 13.369 9.83083 12.6311 9.83083 11.8051C9.83079 10.6833 8.91813 9.77051 7.79625 9.77051ZM8.64195 11.8051C8.64195 12.2714 8.26258 12.6508 7.79625 12.6508C7.45297 12.6508 7.14627 12.4459 7.01491 12.1287C6.8835 11.8115 6.95537 11.4498 7.19812 11.2072C7.36034 11.0449 7.57571 10.959 7.7954 10.959C7.9045 10.959 8.01462 10.9802 8.11982 11.0238C8.43703 11.1552 8.64195 11.4618 8.64195 11.8051Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_786_32782">
        <rect width="15.5912" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
